export function calculateWorkerReliability({
  completedShifts = 0,
  noShows = 0,
  lateArrivals = 0,
  cancellations = 0,
}) {
  const bonus = Math.floor(Number(completedShifts || 0) / 10);

  const score =
    100 -
    Number(noShows || 0) * 20 -
    Number(lateArrivals || 0) * 5 -
    Number(cancellations || 0) * 2 +
    bonus;

  return Math.max(0, Math.min(100, Math.round(score)));
}

export function getWorkerTier(score = 0) {
  const n = Number(score || 0);

  if (n >= 95) return "Gold";
  if (n >= 85) return "Silver";
  if (n >= 75) return "Bronze";
  return "Needs Coaching";
}

export function getWorkerTierIcon(score = 0) {
  const n = Number(score || 0);

  if (n >= 95) return "★★★★★";
  if (n >= 85) return "★★★★";
  if (n >= 75) return "★★★";
  return "★★";
}